class MilestoneTitle {
    constructor(
        $scope,
        milestonesService
    ) {
        this.getList = (list) => {
            return milestonesService.getList(this.milestone.type + list);
        }

    }
}

tenderEdit.component('milestoneTitle', {
    templateUrl: '/static/scripts/modules/TenderEdit/views/components/milestone-title.html',
    controller: MilestoneTitle,
    controllerAs: 'vm',
    bindings: {
        id: '@',
        label: '@',
        ngModel: '=',
        milestone: '<',
        ngDisabled: '<',
        ngRequired: '<',
    }
});
